/*
 * @Date: 2020-08-31 14:11:53
 * @Author: lvjun
 * @Description: mutation-types
 */
export const LOGIN_INIT = 'LOGIN_INIT'
export const SET_USER = 'SET_USER'
export const SET_TOKEN = 'SET_TOKEN'
export const LOGIN_OUT = 'LOGIN_OUT'
export const SET_MENU = 'SET_MENU'
export const SET_BTNLIST = 'SET_BTNLIST'
export const SET_VUESTORAGE = 'SET_VUESTORAGE'
export const SET_TRILLSTORAGE = 'SET_TRILLSTORAGE'
export const SET_IMSTORAGE = 'SET_IMSTORAGE'
export const SET_USER_EXTENSION_NO = 'SET_USER_EXTENSION_NO'
